import { Dropdown, SelectItem } from '@lyse-as/formds-react';
import { useAppSelector } from 'app/hooks/redux-thunk';
import { formatVoipNumber } from 'app/utils/string-util';
import { useTranslation } from 'react-i18next';

interface NumberDropDown {
  selectNumber: (phone: string) => void;
  selectedPhoneNumber: string;
  className?: string;
}

export const NumberDropDown = ({ selectNumber, selectedPhoneNumber, className }: NumberDropDown) => {
  const {
    locations: { data: locationData },
  } = useAppSelector((state) => state.voipSettings);
  const { t } = useTranslation();

  return (
    <Dropdown
      className={className}
      name="phonenumber-chooser"
      placeholder={t('pages.voip.chooseNumber')}
      label={t('pages.voip.chooseNumberLabel')}
      value={selectedPhoneNumber}
      onValueChange={(value: string) => selectNumber(value)}
    >
      {locationData?.map((location) =>
        location.phoneNumbers?.map((phone) => (
          <SelectItem key={phone} value={phone}>
            {formatVoipNumber(phone)}
          </SelectItem>
        )),
      )}
    </Dropdown>
  );
};
